import React from 'react';
import styled from '@emotion/styled';
import { HomeButton } from 'components/views/atoms/HomeButton';
import { SidebarButton } from 'components/views/atoms/SidebarButton';
import { ExitButton } from 'components/views/atoms/ExitButton';
import { ProjectSelector } from 'components/views/molecules/ProjectSelector';
import { EnvironmentSelector } from 'components/views/molecules/EnvironmentSelector';
import { Project } from 'core/models/project';
import { Environment } from 'core/models/environment';
import { Button, styled as materialStyled } from '@mui/material';
import { fontFamily } from 'components/views/default';

//const SettingsMenu = menuWithIcon(faTasks);
//const MailMenu = menuWithIcon(faEnvelope);
//const CalendarMenu = menuWithIcon(faCalendar);

const Root = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#279BE4',
    minHeight: '64px',
});

const LeftItems = styled.div({
    display: 'flex',
    alignItems: 'center',
    padding: ['12px', '19px'],
});

const RightItems = styled.div({
    display: 'flex',
    alignItems: 'center',
});

const StyledButton = materialStyled(Button)({
    color: 'white',
    fontFamily,
});

function PresentationStartButton(props: { onClick?: () => void }) {
    return (
        <StyledButton onClick={props.onClick} disabled={!props.onClick}>
            Multi Screen Mode
        </StyledButton>
    );
}

export type NavigationBarProps = {
    sidebarButtonVisible: boolean;

    projects: Project[];
    selectedProject: Project | null;

    environments: Environment[];
    selectedEnvironment: Environment | null;

    onHomeButtonClick: () => void;
    onSidebarButtonClick: () => void;
    onExitButtonClick: () => void;
    onProjectSelected: (project: Project) => void;
    onEnvironmentSelected: (environment: Environment) => void;

    multiScreenSupported: boolean;
    onMultiScreenClick?: () => void;
}

export const NavigationBar = (props: NavigationBarProps) => {
    return (
        <Root>
            <LeftItems>
                <HomeButton onClick={props.onHomeButtonClick} />
                <SidebarButton visible={props.sidebarButtonVisible} onClick={() => props.onSidebarButtonClick()} />
            </LeftItems>
            <RightItems>
                {
                    props.multiScreenSupported
                        ? <PresentationStartButton onClick={props.onMultiScreenClick} />
                        : <React.Fragment />
                }
                <ProjectSelector projects={props.projects} selected={props.selectedProject} onSelect={props.onProjectSelected} />
                <EnvironmentSelector environments={props.environments} selected={props.selectedEnvironment} onSelect={props.onEnvironmentSelected} />
                <ExitButton onClick={props.onExitButtonClick} />
            </RightItems>
        </Root >
    );
};
